import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-transmission-state',
  templateUrl: './icon-transmission-state.component.html',
  styleUrls: ['./icon-transmission-state.component.scss'],
})
export class IconTransmissionStateComponent {
  @Input() variant:
    | 'inMotion'
    | 'idleWithIgnitionOn'
    | 'idleWithoutIgnition'
    | 'noTransmission'
    | 'noSignalCoverage'
    | 'gpsError'
    | 'undefined' = 'undefined';
  @Input() color: string = '#fff';
  @Input() size: string = '10';
}
